// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.input-field {
    position: relative;
    margin: var(--space-x3) 0;
}
.input-field::placeholder {
    color: var(--disabled-color);
}

.input-field-input {
    background-color: var(--new-input-background-color);
    border: none;
    border-radius: calc( var(--space-half) + 1px );
    padding: var(--space) var(--space-and-half);
    width: 100%;
    font-family: var(--secondary-font);
    font-size: var(--space);
    max-height: var(--space-x3);
}
.input-field-input:active, .input-field-input:focus {
    border: none;
    outline: none;
    
}
.input-field.otp-field .input-field-input {
    text-align: center;
    font-size: var(--space-and-half);
    font-family: var(--primary-font);
    letter-spacing: var(--space);
    line-height: var(--space-x2);
}
.input-field-input.error {
    border: var(--input-field-border-error);
}

.input-field-label {
    position: absolute;
    top: calc( var( --space-and-half ) * -1 );
    left: 0;
    background-color: var(--disabled-sb-bg-color);
    font-weight: var(--font-medium);
    font-family: var(--secondary-font);
    line-height: calc( var(--space) + var(--space-quarter) );
    font-size: calc( var(--space) + 1px );
    letter-spacing: 0.0025em;
    color: var(--basic-gray-color);

}
.input-field__message,
.input-field__tip-message {
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-regular);
    font-size: var(--space-half-quarter);
    line-height: var(--space);
    color: var(--primary-dark-color);
    width: fit-content;
    margin-left: var(--space-x2);
    margin-top: 4px;
    margin-left: var(--space);
    position: relative;
    text-align: left;
}
.input-field__message.error {
    color: var(--error-color);
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/input-field/InputFieldComponent.styles.css"],"names":[],"mappings":";AACA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,4BAA4B;AAChC;;AAEA;IACI,mDAAmD;IACnD,YAAY;IACZ,8CAA8C;IAC9C,2CAA2C;IAC3C,WAAW;IACX,kCAAkC;IAClC,uBAAuB;IACvB,2BAA2B;AAC/B;AACA;IACI,YAAY;IACZ,aAAa;;AAEjB;AACA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,gCAAgC;IAChC,4BAA4B;IAC5B,4BAA4B;AAChC;AACA;IACI,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;IAClB,yCAAyC;IACzC,OAAO;IACP,6CAA6C;IAC7C,+BAA+B;IAC/B,kCAAkC;IAClC,wDAAwD;IACxD,qCAAqC;IACrC,wBAAwB;IACxB,8BAA8B;;AAElC;AACA;;IAEI,kCAAkC;IAClC,kBAAkB;IAClB,gCAAgC;IAChC,oCAAoC;IACpC,yBAAyB;IACzB,gCAAgC;IAChC,kBAAkB;IAClB,4BAA4B;IAC5B,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,yBAAyB;AAC7B","sourcesContent":["\n.input-field {\n    position: relative;\n    margin: var(--space-x3) 0;\n}\n.input-field::placeholder {\n    color: var(--disabled-color);\n}\n\n.input-field-input {\n    background-color: var(--new-input-background-color);\n    border: none;\n    border-radius: calc( var(--space-half) + 1px );\n    padding: var(--space) var(--space-and-half);\n    width: 100%;\n    font-family: var(--secondary-font);\n    font-size: var(--space);\n    max-height: var(--space-x3);\n}\n.input-field-input:active, .input-field-input:focus {\n    border: none;\n    outline: none;\n    \n}\n.input-field.otp-field .input-field-input {\n    text-align: center;\n    font-size: var(--space-and-half);\n    font-family: var(--primary-font);\n    letter-spacing: var(--space);\n    line-height: var(--space-x2);\n}\n.input-field-input.error {\n    border: var(--input-field-border-error);\n}\n\n.input-field-label {\n    position: absolute;\n    top: calc( var( --space-and-half ) * -1 );\n    left: 0;\n    background-color: var(--disabled-sb-bg-color);\n    font-weight: var(--font-medium);\n    font-family: var(--secondary-font);\n    line-height: calc( var(--space) + var(--space-quarter) );\n    font-size: calc( var(--space) + 1px );\n    letter-spacing: 0.0025em;\n    color: var(--basic-gray-color);\n\n}\n.input-field__message,\n.input-field__tip-message {\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-regular);\n    font-size: var(--space-half-quarter);\n    line-height: var(--space);\n    color: var(--primary-dark-color);\n    width: fit-content;\n    margin-left: var(--space-x2);\n    margin-top: 4px;\n    margin-left: var(--space);\n    position: relative;\n    text-align: left;\n}\n.input-field__message.error {\n    color: var(--error-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
